<template>
  <v-app>
    <navigation 
      v-if="authenticated && showNavigation"
      :navigationItems="navigationItems"
      :userType="'admin'"
    ></navigation>
      <v-main class="bg">
        <v-container
          v-if="showNavigation"
        >
        <breadcrumbs class="px-0 py-1"
          :routes="routes"
        ></breadcrumbs>
        <h1 class="title">{{pageTitle}}</h1>
        </v-container>
        <router-view></router-view>
    </v-main>
    <notifications></notifications>
    <base-loader></base-loader>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation'
import Breadcrumbs from './components/Breadcrumbs'
import Notifications from './components/Notifications'
import BaseLoader from './components/BaseLoader'
import { mapGetters } from 'vuex'
import router from './router/admin';
import {navigation_items} from './router/admin/routes'
import {routes} from './router/admin/routes'

export default {
  router,
  name: 'App',
  components: {
    BaseLoader,
    Navigation,
    Breadcrumbs,
    Notifications,
  },
  computed: {
    ...mapGetters('auth', {
      authenticated: 'authenticated'
    }),
    navigationItems () {
      return navigation_items
    },
    routes () {
      return routes
    },
    pageTitle () {
      return this.$route.meta.title
    },
    showNavigation () {
      return this.$route.name !== 'survey_sections_edit_preview'
    }
  },
  created () {
    if(this.authenticated){
      this.$store.dispatch('surveySection/all')
      this.$store.dispatch('language/all')
    }
  }
};
</script>
<style lang="scss" scoped>
@media (min-width: 1904px) {
  .container {
    max-width: 1600px;
  }
}
</style>
